'use strict';


import * as og    from 'og';
//const ogPath = new URL(import.meta.url).searchParams.get('ogPath');
//
//let og = await import(ogPath);

/**
 * Control displays mouse or screen center Earth coordinates.
 * @class
 * @extends {og.control.Control}
 * @param {Object} [options] - Options:
 * @param {Boolean} [options.center] - Earth coordiantes by screen center otherwise mouse pointer. False is default.
 * @param {Boolean} [options.type] - Coordinates shown: 0 - is decimal degrees, 1 - degrees, 2 - mercator geodetic coordinates.
 */
class EarthCoordinates extends og.control.EarthCoordinates {
    constructor(options) {
        super(options);

//        options = options || {};
//
//        /**
//         * Display type.
//         * @private
//         * @type {Boolean}
//         */
//        this._type = options.type || 0;
//
//        this._TYPE_FUNC = [this._SHOW_DECIMAL, this._SHOW_DEGREE];
//
//        this._showFn = null;
//
//        /**
//         * Current position.
//         * @public
//         * @type {og.Vec3}
//         */
//        this._lonLat = new LonLat();

    }

    _SHOW_DECIMAL(ll) {
        if (ll) {
            let lat = ll.lat,
                    lon = ll.lon;




            let text = `${Math.abs(lon).toFixed(5) + '°'}${lon >= 0 ? 'E' : 'W'} ${Math.abs(lat).toFixed(5) + '°'}${lat >= 0 ? 'N' : 'S'} `;

            this._el.innerText = text;
        }
    }

    _SHOW_DEGREE(ll) {
        if (ll) {
            let lat = ll.lat,
                    lon = ll.lon;


            let t = 0;

            let deg = lat < 0 ? Math.ceil(lat) : Math.floor(lat);
            let min = Math.floor(t = Math.abs((lat - deg)) * 60);
            let sec = Math.floor((t - min) * 6000) / 100.0;
            let latStr = Math.abs(deg) + '°' + min + "'" + sec.toFixed(0) + '"';

            deg = lon < 0 ? Math.ceil(lon) : Math.floor(lon);
            min = Math.floor(t = Math.abs((lon - deg)) * 60);
            sec = Math.floor((t - min) * 6000) / 100.0;

            let  lonStr = Math.abs(deg) + '°' + min + "'" + sec.toFixed(0) + '"';


            let text = `${lonStr}${lon >= 0 ? 'E' : 'W'} ${latStr}${lat >= 0 ? 'N' : 'S'} `;

            this._el.innerText = text;
        }
    }

    _refreshCoordinates() {

        if (this._type >= this._TYPE_FUNC.length) {
            this._type = 0;
        }

        this._showFn = this._TYPE_FUNC[this._type];
        this._showFn(this._lonLat);
    }

    oninit() {
        this._el = document.getElementById('sg-globus-coordinates');

        this._el.addEventListener("click", () => {
            this._type++;
            this._refreshCoordinates();
        });

        if (this._centerMode) {
            this.renderer.activeCamera.events.on("moveend", this._grabCoordinates, this);
        } else {
            this.renderer.events.on("mousemove", this._grabCoordinates, this);
        }

        this._refreshCoordinates();

    }

    _grabCoordinates(px) {
        let scrPx;
        let r = this.renderer;
        if (this._centerMode) {
            scrPx = r.handler.getCenter();
        } else {
            scrPx = px;
        }
        this._lonLat = this.planet.getLonLatFromPixelTerrain(scrPx);
        this._showFn(this._lonLat);
    }

}

class RulerControl extends og.control.Ruler {
    constructor(options) {
        super(options);
    }

    setActive(active) {
        let self = this;
        if (active) {
            self.activate();
        } else {
            self.deactivate();
        }
    }

}


class SelectionControl extends og.control.Selection {

    constructor(options = {}) {
        super(options);
    }

    oninit() {
        this._selectorScene.bindPlanet(this.planet);

    }

    setActive(active) {
        let self = this;
        if (active) {
            self.activate();
        } else {
            self.deactivate();
        }
    }

}


class SelectionFeatures extends  SelectionControl
{
    _featureURL = null

    onSelect = (extent) => {

        var vectorSource = new ol.source.Vector({
            format: new GeoJSON(),
            url: function (extent) {
                let singlePoint = false;
                if (extent[1] === extent[3]) {
                    extent[1] -= 0.0001;
                    extent[3] += 0.0001;
                    singlePoint = true;
                }

                if (extent[0] === extent[2]) {
                    extent[0] -= 0.0001;
                    extent[2] += 0.0001;
                    singlePoint = true;
                }
                let dx = extent[2] - extent[0];
                let dy = extent[3] - extent[1];
                let ratio = dy / dx;
                let h = 10;
                let w = 10;
                let x = 5;
                let y = 5;
//                    return 'http://192.168.56.107/geoserver/snap/ows?service=WMS&' +
//                            'version=1.1.1&request=GetFeatureInfo&layers=snap:AllNavigations' +
//                            '&query_layers=snap:AllNavigations&' +
//                            `FEATURE_COUNT=50&X=${x}&Y=${y}&width=${w}&height=${h}` + '&info_format=application/json&srs=EPSG:4326&' +
//                            'bbox=' + extent.join(',') ;

                if (!singlePoint) {
                    this.planet.viewExtentArr(extent);
                }
                let url = this._featureURL;
                if (typeof this._featureURL === 'function') {
                    url = this._featureURL.call(this);
                }
                return url;//&maxFeatures=10&filter=%3CFilter%3E%3CPropertyIsEqualTo%3E%3CPropertyName%3Ename%3C/PropertyName%3E%3CLiteral%3ED-499/D-499.uko%3C/Literal%3E%3C/PropertyIsEqualTo%3E%3C/Filter%3E
            },
            strategy: function (extent, resolution) {
                if (this.resolution && this.resolution != resolution) {
                    this.loadedExtentsRtree_.clear();
                }
                return [extent];
            }
        });

        vectorSource.loadFeatures(extent);
        console.log(extent);

    }

    constructor(options = {}){
        super(options);

        this._featureURL = options['featureURL'];
        this._selectorScene._onSelect = this.onSelect;
    }

}
;


class SelectionZoom extends SelectionControl
{

    onSelect = (extent) => {

        if (extent[1] === extent[3] || extent[0] === extent[2]) {
            return;
        }

        this.planet.viewExtentArr(extent);
    }

    constructor(options = {}){
        super(options);

        this._selectorScene._onSelect = this.onSelect;
    }

}
;


/**
 * Planet compass button
 * @class
 * @extends {Control}
 * @params {Object} [options] - Control options.
 */
class CustomCompassButton extends og.control.CompassButton {
    constructor(options = {}) {
        super(options);
        this._heading = null;
        this._svg = options['svg'] || null;
    }

    oninit() {
        if (this._svg) {
            let btn = new og.Button({
                classList: ["og-map-button", "og-compass-button"],
                icon: this._svg
            });

            btn.appendTo(this.renderer.div);

            btn.on("click", this._onClick, this);

            this._svg = btn.select("svg");

            this.renderer.events.on("draw", this._draw, this);
        } else {

        }

    }

}


export { CustomCompassButton, EarthCoordinates, RulerControl, SelectionControl, SelectionFeatures, SelectionZoom }
;
